<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="配置备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'configRemark', validatorRules.configRemark]" placeholder="请输入配置备注"></a-input>
        </a-form-item>
        <a-form-item label="配置类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['configType', validatorRules.configType]" :trigger-change="true" dictCode="standard_team_task_type" placeholder="请选择配置类型"/>
        </a-form-item>
        <a-form-item label="开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'startTime', validatorRules.startTime]" placeholder="请输入开始时间"></a-input>
        </a-form-item>
        <a-form-item label="结束时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'endTime', validatorRules.endTime]" placeholder="请输入结束时间"></a-input>
        </a-form-item>
        <a-form-item label="配置名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'configName', validatorRules.configName]" placeholder="请输入配置名称"></a-input>
        </a-form-item>
        <a-form-item label="任务生成类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'createTaskType', validatorRules.createTaskType]" placeholder="请输入任务生成类型"></a-input>
        </a-form-item>
        <a-form-item label="计划次数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'planNum', validatorRules.planNum]" placeholder="请输入计划次数" style="width: 100%"/>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  
  export default {
    name: "BusStandardTeamConfigAddModal",
    components: { 
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          configRemark: {rules: [
            {required: true, message: '请输入配置备注!'},
          ]},
          configType: {rules: [
            {required: true, message: '请输入配置类型!'},
          ]},
          startTime: {rules: [
            {required: true, message: '请输入开始时间!'},
          ]},
          endTime: {rules: [
            {required: true, message: '请输入结束时间!'},
          ]},
          configName: {rules: [
          ]},
          createTaskType: {rules: [
          ]},
          planNum: {rules: [
          ]},
        },
        url: {
          add: "/standardTeam/busStandardTeamConfig/add",
          edit: "/standardTeam/busStandardTeamConfig/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'configRemark','configType','startTime','endTime','delFlag','baseId','configName','createTaskType','planNum'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'configRemark','configType','startTime','endTime','delFlag','baseId','configName','createTaskType','planNum'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>